import { LiveSearchMetadataGridComponent } from './component/LiveSearchMetadataGridComponent';
import { WEB_COMPONENT_LIVE_SEARCH_METADATA_GRID } from '../../../webcomponents.constants';

export { LiveSearchMetadataGridComponent };

window.customElements.define(WEB_COMPONENT_LIVE_SEARCH_METADATA_GRID, LiveSearchMetadataGridComponent);
